import { css } from "styled-system/css";
import { ak as shared } from "~/components/editorial/admin-styles";

// The shared admin styles plus the pieces only the settings pages use:
// setup steps, sync progress, the ledger strip and row states.

export const ak = {
  ...shared,
  steps: css({
    m: 0,
    pl: 0,
    listStyle: "none",
    counterReset: "step",
    fontSize: "14px",
    lineHeight: 1.5,
    "& li": {
      counterIncrement: "step",
      position: "relative",
      pl: "30px",
      py: "6px",
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderColor: "ed.grid",
    },
    "& li::before": {
      content: "counter(step, decimal-leading-zero)",
      position: "absolute",
      left: 0,
      top: "8px",
      fontFamily: "mono",
      fontSize: "12px",
      color: "ed.ink3",
    },
  }),
  meta: css({
    fontSize: "12px",
    color: "ed.ink3",
    lineHeight: 1.5,
    "& .num, & time": {
      fontFamily: "mono",
      fontVariantNumeric: "tabular-nums",
      color: "ed.ink2",
    },
  }),
  formRow: css({
    display: "grid",
    gridTemplateColumns: { base: "1fr", sm: "1fr 1fr" },
    gap: "0 16px",
  }),
  spinning: css({ animation: "spin 1s linear infinite" }),
  rowMuted: css({ color: "ed.ink3", "& td": { color: "ed.ink3" } }),
  progress: css({
    height: "4px",
    bg: "ed.grid",
    overflow: "hidden",
    maxWidth: "420px",
    "& > div": {
      height: "100%",
      bg: "ed.ink",
      transition: "width 300ms cubic-bezier(0.2, 0, 0, 1)",
    },
  }),

  // ── Ledger strip (counts without a prior period) ─────────────────────
  ledger: css({
    display: "grid",
    gridTemplateColumns: {
      base: "repeat(2, minmax(0, 1fr))",
      md: "repeat(var(--cols), minmax(0, 1fr))",
    },
    borderTopWidth: "2px",
    borderTopStyle: "solid",
    borderColor: "ed.ink",
    m: 0,
    mt: "20px",
  }),
  ledgerCell: css({
    px: "12px",
    pt: "10px",
    pb: "12px",
    borderRightWidth: "1px",
    borderRightStyle: "solid",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderColor: "ed.rule",
    minWidth: 0,
    "&:first-child": { pl: 0 },
    "& dt": {
      fontFamily: "sans",
      fontSize: "10.5px",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "ed.ink2",
    },
    "& dd": { m: 0 },
  }),
  ledgerValue: css({
    fontFamily: "mono",
    fontVariantNumeric: "tabular-nums",
    fontSize: "26px",
    fontWeight: 600,
    lineHeight: 1.15,
    mt: "4px",
  }),
  ledgerNote: css({
    fontFamily: "sans",
    fontSize: "11.5px",
    color: "ed.ink3",
    mt: "2px",
  }),
};
